import { render, staticRenderFns } from "./one copy.vue?vue&type=template&id=2cd1b5a5&scoped=true&"
import script from "./one copy.vue?vue&type=script&lang=js&"
export * from "./one copy.vue?vue&type=script&lang=js&"
import style0 from "./one copy.vue?vue&type=style&index=0&id=2cd1b5a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1b5a5",
  null
  
)

export default component.exports